import randomcolor from 'randomcolor'
import { getContrastColorString } from '@/util'

export default {
  install (Vue) {
    Vue.prototype.$randomColor = randomcolor.bind(null, { luminosity: 'light' })
    Vue.prototype.$contrastColorString = getContrastColorString
  }
}
